export default function EVMWalletsLogo({ className }: { className?: string }) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M60.3826 8L39.2656 23.625L43.1926 14.417L60.3826 8Z"
        fill="#E17726"
      />
      <path
        d="M11.6715 8L32.6015 23.77L28.8615 14.417L11.6715 8ZM52.7785 44.229L47.1595 52.812L59.1905 56.125L62.6375 44.417L52.7785 44.229ZM9.43945 44.416L12.8645 56.125L24.8745 52.812L19.2765 44.229L9.43945 44.416Z"
        fill="#E27625"
      />
      <path
        d="M24.2287 29.73L20.8867 34.77L32.7917 35.312L32.3957 22.5L24.2287 29.73ZM47.8297 29.73L39.5377 22.354L39.2657 35.313L51.1717 34.771L47.8297 29.73ZM24.8757 52.812L32.0807 49.332L25.8767 44.499L24.8757 52.812ZM39.9757 49.333L47.1607 52.813L46.1787 44.499L39.9757 49.333Z"
        fill="#E27625"
      />
      <path
        d="M47.159 52.812L39.974 49.332L40.559 54.001L40.496 55.98L47.159 52.812ZM24.873 52.813L31.557 55.98L31.515 54L32.079 49.333L24.873 52.813Z"
        fill="#D5BFB2"
      />
      <path
        d="M31.683 41.417L25.709 39.667L29.929 37.729L31.683 41.417ZM40.374 41.417L42.129 37.729L46.369 39.667L40.374 41.417Z"
        fill="#233447"
      />
      <path
        d="M24.8724 52.812L25.9174 44.229L19.2754 44.416L24.8724 52.812ZM46.1364 44.229L47.1604 52.812L52.7784 44.416L46.1364 44.229ZM51.1704 34.771L39.2654 35.313L40.3724 41.417L42.1274 37.729L46.3674 39.667L51.1714 34.771H51.1704ZM25.7104 39.667L29.9294 37.729L31.6834 41.417L32.7914 35.312L20.8864 34.771L25.7104 39.667Z"
        fill="#CC6228"
      />
      <path
        d="M20.8867 34.77L25.8767 44.5L25.7097 39.667L20.8867 34.77ZM46.3697 39.667L46.1807 44.5L51.1727 34.77L46.3697 39.667ZM32.7917 35.312L31.6857 41.416L33.0857 48.625L33.3987 39.125L32.7917 35.312ZM39.2657 35.313L38.6817 39.103L38.9747 48.624L40.3747 41.417L39.2657 35.313Z"
        fill="#E27525"
      />
      <path
        d="M40.374 41.417L38.974 48.624L39.975 49.333L46.18 44.5L46.369 39.667L40.374 41.417ZM25.71 39.667L25.876 44.499L32.08 49.333L33.083 48.625L31.683 41.417L25.71 39.667Z"
        fill="#F5841F"
      />
      <path
        d="M40.496 55.98L40.559 54L40.016 53.542H32.037L31.515 54.001L31.557 55.98L24.873 52.813L27.213 54.729L31.952 58H40.078L44.84 54.73L47.158 52.812L40.495 55.98H40.496Z"
        fill="#C0AC9D"
      />
      <path
        d="M39.9746 49.333L38.9716 48.625H33.0816L32.0796 49.333L31.5156 54L32.0376 53.54H40.0166L40.5596 54L39.9746 49.333Z"
        fill="#161616"
      />
      <path
        d="M61.28 24.646L63.055 16.021L60.382 8L39.975 23.104L47.829 29.729L58.919 32.959L61.363 30.104L60.298 29.334L61.99 27.792L60.695 26.792L62.387 25.5L61.28 24.646ZM9 16.02L10.796 24.646L9.648 25.5L11.36 26.792L10.065 27.792L11.757 29.333L10.692 30.104L13.136 32.958L24.228 29.729L32.08 23.104L11.672 8L9 16.02Z"
        fill="#763E1A"
      />
      <path
        d="M58.9205 32.959L47.8305 29.729L51.1715 34.77L46.1795 44.5L52.7795 44.417H62.6375L58.9195 32.959H58.9205ZM24.2275 29.73L13.1355 32.958L9.43945 44.416L19.2765 44.417L25.8765 44.499L20.8855 34.771L24.2275 29.73ZM39.2665 35.313L39.9765 23.104L43.1915 14.417H28.8645L32.0795 23.104L32.7905 35.312L33.0625 39.146L33.0835 48.624H38.9735L38.9945 39.146L39.2665 35.313Z"
        fill="#F5841F"
      />
      <path
        d="M60.382 8L39.265 23.625L43.192 14.417M60.382 8L43.192 14.417M60.382 8L63.055 16.02L61.28 24.646L62.387 25.5L60.695 26.792L61.99 27.792L60.298 29.333L61.363 30.104L58.919 32.958L47.829 29.729L39.975 23.104L60.382 8ZM43.192 14.417L39.977 23.105L39.267 35.313L38.995 39.146L38.974 48.624M43.192 14.417H28.865L32.08 23.104M38.974 48.624L39.975 49.332M38.974 48.624L40.374 41.417L46.369 39.667M38.974 48.624H33.084M32.08 23.104L11.672 8M32.08 23.104L24.228 29.729M32.08 23.104L32.791 35.312M11.672 8L32.602 23.77L28.862 14.417L11.672 8ZM11.672 8L9 16.02L10.796 24.646L9.648 25.5L11.36 26.792L10.065 27.792L11.757 29.333L10.692 30.104L13.136 32.958M13.136 32.958L9.44 44.416M13.136 32.958L24.228 29.729M47.16 52.812L52.779 44.229L62.638 44.417M47.16 52.812L59.191 56.125L62.638 44.417M47.16 52.812L39.975 49.332M47.16 52.812L46.178 44.499L39.975 49.332M47.16 52.812L40.497 55.98L40.56 54M47.16 52.812L46.136 44.229L52.778 44.416L47.16 52.812ZM47.16 52.812L44.842 54.729L40.08 58H31.955L27.213 54.73L24.873 52.813M62.638 44.417H52.78L46.18 44.5M62.638 44.417L58.92 32.959L47.83 29.729M39.975 49.332L40.56 54M39.975 49.332L46.18 44.5M39.975 49.332L38.972 48.625H33.082L31.683 41.417M40.56 54L40.017 53.541H32.038L31.516 54M24.873 52.813L25.917 44.229L19.275 44.416L24.873 52.813ZM46.18 44.5L46.369 39.667M46.18 44.5L51.171 34.77M47.83 29.729L51.171 34.77M47.83 29.729L39.538 22.355L39.266 35.314M47.83 29.729L51.172 34.772M51.171 34.77L46.369 39.667M9.44 44.416L12.865 56.125L24.875 52.812M9.44 44.416L19.277 44.229L24.875 52.812M9.44 44.416L19.277 44.417L25.877 44.499L32.081 49.334L31.516 54M24.875 52.812L32.08 49.332L33.084 48.624M24.875 52.812L25.876 44.499M25.876 44.499L20.886 34.771M25.876 44.499L25.709 39.667M24.228 29.729L20.886 34.771M24.228 29.729L32.394 22.5L32.791 35.312M20.886 34.771L32.791 35.312M20.886 34.771L25.709 39.667M32.791 35.312L31.683 41.417M32.791 35.312L31.685 41.416L33.085 48.625L33.398 39.125L32.791 35.312ZM32.791 35.312L33.063 39.146L33.084 48.624M25.709 39.667L31.683 41.417M25.709 39.667L29.929 37.729L31.683 41.417M39.266 35.314L51.172 34.772M39.266 35.314L40.373 41.418M39.266 35.314L38.682 39.104L38.975 48.625M39.266 35.314L40.375 41.418M51.172 34.772L46.368 39.668L42.128 37.73L40.373 41.418M40.373 41.418L42.129 37.729L46.369 39.667M31.516 54L31.558 55.98L24.874 52.813"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59 82C59 75.373 53.627 70 47 70H21C14.373 70 9 75.373 9 82V108C9 114.627 14.373 120 21 120H47C53.627 120 59 114.627 59 108V82Z"
        fill="#3B99FC"
      />
      <path
        d="M23.9819 88.5252C29.5149 82.9922 38.4849 82.9922 44.0179 88.5252L44.6839 89.1912C44.8166 89.324 44.8911 89.504 44.8911 89.6917C44.8911 89.8794 44.8166 90.0595 44.6839 90.1922L42.4059 92.4712C42.3395 92.5374 42.2496 92.5746 42.1559 92.5746C42.0622 92.5746 41.9723 92.5374 41.9059 92.4712L40.9889 91.5542C37.1289 87.6942 30.8709 87.6942 27.0109 91.5542L26.0299 92.5352C25.997 92.5682 25.958 92.5943 25.915 92.6121C25.872 92.6299 25.8259 92.6391 25.7794 92.6391C25.7329 92.6391 25.6868 92.6299 25.6438 92.6121C25.6008 92.5943 25.5618 92.5682 25.5289 92.5352L23.2509 90.2572C23.1182 90.1245 23.0437 89.9444 23.0437 89.7567C23.0437 89.569 23.1182 89.389 23.2509 89.2562L23.9819 88.5252ZM48.7299 93.2352L50.7569 95.2632C50.8227 95.329 50.875 95.4071 50.9106 95.4931C50.9463 95.579 50.9646 95.6712 50.9646 95.7642C50.9646 95.8573 50.9463 95.9494 50.9106 96.0354C50.875 96.1214 50.8227 96.1995 50.7569 96.2652L41.6149 105.407C41.4818 105.54 41.3017 105.614 41.1139 105.614C40.9261 105.614 40.746 105.54 40.6129 105.407L34.1249 98.9192C34.0917 98.8861 34.0468 98.8676 33.9999 98.8676C33.953 98.8676 33.9081 98.8861 33.8749 98.9192L27.3869 105.407C27.2538 105.54 27.0737 105.614 26.8859 105.614C26.6981 105.614 26.518 105.54 26.3849 105.407L17.2429 96.2652C17.177 96.1995 17.1248 96.1214 17.0891 96.0354C17.0535 95.9494 17.0352 95.8573 17.0352 95.7642C17.0352 95.6712 17.0535 95.579 17.0891 95.4931C17.1248 95.4071 17.177 95.329 17.2429 95.2632L19.2709 93.2362C19.4037 93.1035 19.5837 93.029 19.7714 93.029C19.9591 93.029 20.1391 93.1035 20.2719 93.2362L26.7609 99.7242C26.8299 99.7932 26.9419 99.7932 27.0109 99.7242L33.4989 93.2362C33.5647 93.1704 33.6427 93.1181 33.7287 93.0825C33.8147 93.0468 33.9068 93.0285 33.9999 93.0285C34.093 93.0285 34.1851 93.0468 34.2711 93.0825C34.357 93.1181 34.4351 93.1704 34.5009 93.2362L40.9889 99.7242C41.0589 99.7932 41.1699 99.7932 41.2389 99.7242L47.7279 93.2362C47.8608 93.1035 48.041 93.0289 48.2289 93.0289C48.4168 93.0289 48.597 93.1025 48.7299 93.2352Z"
        fill="white"
      />
      <path
        d="M119 82C119 75.373 113.627 70 107 70H81C74.373 70 69 75.373 69 82V108C69 114.627 74.373 120 81 120H107C113.627 120 119 114.627 119 108V82Z"
        fill="url(#paint0_linear_4777_700)"
      />
      <path
        d="M77.332 83.333C77.332 83.996 77.5954 84.6319 78.0643 85.1008C78.5331 85.5696 79.169 85.833 79.832 85.833C92.719 85.833 103.166 96.28 103.166 109.167C103.166 109.83 103.429 110.466 103.898 110.935C104.367 111.404 105.003 111.667 105.666 111.667H108.166C108.829 111.667 109.465 111.404 109.934 110.935C110.403 110.466 110.666 109.83 110.666 109.167C110.666 92.137 96.861 78.333 79.832 78.333C79.169 78.333 78.5331 78.5964 78.0643 79.0652C77.5954 79.5341 77.332 80.17 77.332 80.833V83.333Z"
        fill="url(#paint1_radial_4777_700)"
      />
      <path
        d="M104 109.167H110.667C110.667 109.83 110.404 110.466 109.935 110.935C109.466 111.404 108.83 111.667 108.167 111.667H104V109.167Z"
        fill="url(#paint2_linear_4777_700)"
      />
      <path
        d="M79.832 78.333V85H77.332V80.833C77.332 80.17 77.5954 79.5341 78.0643 79.0652C78.5331 78.5964 79.169 78.333 79.832 78.333Z"
        fill="url(#paint3_linear_4777_700)"
      />
      <path
        d="M77.332 85H79.832C93.179 85 103.999 95.82 103.999 109.167V111.667H98.999C98.336 111.667 97.7001 111.404 97.2313 110.935C96.7624 110.466 96.499 109.83 96.499 109.167C96.499 99.962 89.037 92.5 79.832 92.5C79.169 92.5 78.5331 92.2366 78.0643 91.7678C77.5954 91.2989 77.332 90.663 77.332 90V85Z"
        fill="url(#paint4_radial_4777_700)"
      />
      <path
        d="M97.332 109.167H103.999V111.667H97.332V109.167Z"
        fill="url(#paint5_linear_4777_700)"
      />
      <path
        d="M77.332 91.667V85H79.832V91.667H77.332Z"
        fill="url(#paint6_linear_4777_700)"
      />
      <path
        d="M77.332 95.833C77.332 96.1613 77.3967 96.4864 77.5223 96.7897C77.648 97.093 77.8321 97.3686 78.0643 97.6008C78.2964 97.8329 78.572 98.0171 78.8753 98.1427C79.1786 98.2683 79.5037 98.333 79.832 98.333C85.815 98.333 90.666 103.184 90.666 109.167C90.666 109.83 90.9294 110.466 91.3983 110.935C91.8671 111.404 92.503 111.667 93.166 111.667H97.332V109.167C97.332 99.502 89.497 91.667 79.832 91.667H77.332V95.833Z"
        fill="url(#paint7_radial_4777_700)"
      />
      <path
        d="M90.668 109.167H97.334V111.667H93.168C92.5049 111.667 91.869 111.404 91.4002 110.935C90.9314 110.466 90.668 109.83 90.668 109.167Z"
        fill="url(#paint8_radial_4777_700)"
      />
      <path
        d="M79.832 98.333C79.5037 98.333 79.1786 98.2683 78.8753 98.1427C78.572 98.0171 78.2964 97.8329 78.0643 97.6008C77.8321 97.3686 77.648 97.093 77.5223 96.7897C77.3967 96.4864 77.332 96.1613 77.332 95.833V91.667H79.832V98.333Z"
        fill="url(#paint9_radial_4777_700)"
      />
      <g clipPath="url(#clip0_4777_700)">
        <path d="M122 8H72V58H122V8Z" fill="#AB9FF2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.7348 40.089C91.8727 42.9425 88.7523 46.5535 84.6002 46.5535C82.6373 46.5535 80.75 45.7454 80.75 42.2354C80.75 33.2963 92.9547 19.4585 104.279 19.4585C110.721 19.4585 113.288 23.928 113.288 29.0036C113.288 35.5185 109.06 42.9677 104.858 42.9677C103.524 42.9677 102.87 42.2354 102.87 41.0738C102.87 40.7708 102.92 40.4426 103.021 40.089C101.586 42.5385 98.818 44.8111 96.2261 44.8111C94.3388 44.8111 93.3825 43.6243 93.3825 41.9577C93.3825 41.3516 93.5084 40.7203 93.7348 40.089ZM103.489 28.8275C103.489 30.3065 102.617 31.046 101.641 31.046C100.65 31.046 99.792 30.3065 99.792 28.8275C99.792 27.3485 100.65 26.609 101.641 26.609C102.617 26.609 103.489 27.3485 103.489 28.8275ZM109.035 28.8276C109.035 30.3066 108.162 31.0461 107.186 31.0461C106.195 31.0461 105.338 30.3066 105.338 28.8276C105.338 27.3487 106.195 26.6092 107.186 26.6092C108.162 26.6092 109.035 27.3487 109.035 28.8276Z"
          fill="#FFFDF8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4777_700"
          x1="94"
          y1="70"
          x2="94"
          y2="120"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#174299" />
          <stop offset="1" stopColor="#001E59" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4777_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.749 116.25) rotate(-90) scale(46.25)"
        >
          <stop offset="0.77" stopColor="#FF4000" />
          <stop offset="1" stopColor="#8754C9" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_4777_700"
          x1="65.875"
          y1="95"
          x2="119"
          y2="95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF4000" />
          <stop offset="1" stopColor="#8754C9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4777_700"
          x1="93.999"
          y1="70"
          x2="93.999"
          y2="123.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8754C9" />
          <stop offset="1" stopColor="#FF4000" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_4777_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(73.686 115.313) rotate(-90) scale(45.3125)"
        >
          <stop offset="0.724" stopColor="#FFF700" />
          <stop offset="1" stopColor="#FF9901" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_4777_700"
          x1="68.999"
          y1="95"
          x2="118.999"
          y2="95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF700" />
          <stop offset="1" stopColor="#FF9901" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4777_700"
          x1="93.999"
          y1="120"
          x2="93.999"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF700" />
          <stop offset="1" stopColor="#FF9901" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_4777_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(75.249 113.75) rotate(-90) scale(43.75)"
        >
          <stop offset="0.595" stopColor="#00AAFF" />
          <stop offset="1" stopColor="#01DA40" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_4777_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(65.876 95) scale(53.125 377.778)"
        >
          <stop stopColor="#00AAFF" />
          <stop offset="1" stopColor="#01DA40" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4777_700"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(78.581 98.75) rotate(-90) scale(7.08333 134.321)"
        >
          <stop stopColor="#00AAFF" />
          <stop offset="1" stopColor="#01DA40" />
        </radialGradient>
        <clipPath id="clip0_4777_700">
          <rect x="72" y="8" width="50" height="50" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
